module.exports = __webpack_public_path__ + "1c79ec3246bfb4fe9b69385b84d74cda.fbx";